// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Nx5X","vLegacy":"SelectSecondary_vLegacy__2TQov","error":"SelectSecondary_error__1vMc8","disabled":"SelectSecondary_disabled__26TA4"};